module.exports = __webpack_public_path__ + "img/logo.abf58324.svg";